export const getFirmeComponent = () => {
  return {
    widgets: [
      {
        code: '15793',
        name: 'ATTIVA_REVOCA_FIRMA',
        bundleLink: null,
        bundleCode: null,
        position: 1,
        components: [
          {
            name: 'FIRMA',
            value: 'ATTIVA',
            rawValue: null,
            status: [],
            errorMessage: [],
            validations: [],
            values: [],
            type: 'sella',
            pullTo: 'right'
            // position: 3
          },
          {
            name: 'LABEL',
            value: 'Scegli un codice PIN di firma di 5 cifre e inserisci il codice OTP di firma che hai appena ricevuto sul tuo numero di cellulare',
            rawValue: null,
            status: [],
            errorMessage: [],
            validations: [],
          },
          {
            name: 'IFRAME',
            value: '',
            rawValue: null,
            active: true,
            status: ['hidden'],
            errorMessage: [],
            validations: [],
            values: [],
            type: 'iframe',
            position: 5
          },
          {
            name: 'LINK_ADDENDUM',
            value:
              'http://www.trusttechnologies.it/document_loader.aspx?idDocument=58',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: [],
            values: [],
            type: null
          },
          {
            name: 'LINK_ISTRUZIONI',
            value:
              'http://www.trusttechnologies.it/document_loader.aspx?idDocument=150',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: [],
            values: [],
            type: null
          },
          {
            name: 'LINK_MANUALE',
            value:
              'https://www.sella.it/SSRDocumentDisplayer?dtdPG=IS_OP_SELLADIGIT_PIN_SMS&dtdPE=1',
            rawValue: null,
            active: true,
            status: [],
            errorMessage: [],
            validations: [],
            values: [],
            type: null
          },
          {
            name: 'VISIONE',
            value: '',
            rawValue: null,
            active: true,
            status: ['checkonly'],
            errorMessage: [],
            validations: [],
            values: [],
            type: null
          },
          {
            name: 'MODAL',
            value: '',
            title: 'Messaggio',
            active: true,
            status: ['hidden'],
            type: 'alert'
          }
        ],
        status: [],
        errorMessage: []
      }
      /*  {
         code: '15794',
         name: 'FIRMA',
         bundleLink: null,
         bundleCode: null,
         position: 2,
         components: [
           {
             name: 'IFRAME',
             value: '',
             rawValue: null,
             active: true,
             status: [],
             errorMessage: [],
             validations: [],
             values: [],
             type: null
           }
         ],
         status: [],
         errorMessage: []
       } */
    ]
  }
}

export const getDiFarmaComponents = () => {
  return {
    widgets: [
      {
        code: '15865',
        name: 'DIFARMA',
        bundleLink: null,
        bundleCode: null,
        position: 3,
        components: [
          {
            name: 'LABEL',
            value: 'Firma il contratto',
            active: true,
            status: [],
            errorMessage: [],
            validations: [],
            values: [],
            type: 'label',
            position: 1
          },
          {
            name: 'SUB_LABEL',           
           value:
           'Ho letto il contratto ed accetto termini e condizioni',
             // 'Ti verr&agrave; inviato un codice alfanumerico via SMS che dovrai utilizzare per firmare il contratto assieme al PIN di firma.',          
            active: true,
            status: [],
            errorMessage: [],
            validations: [],
            values: [],
            type: 'label',
            position: 2
          },
          {
            name: 'FIRMA',
            value: 'Accetta', 
            rawValue: null,
            active: true,
            disabled: true,
            status: [],
            url: '',
            errorMessage: [],
            validations: [],
            values: [],
            type: 'inverse',
            pullTo: 'right',
            position: 3
            /* action: {
              value: 'Attivata',
              type: 'inverse',
              disabled: true,
              fetch: {
                attivata: {
                  url: 'wgt/sign/url',
                  body: {},
                  mappingEvent: 'IframeSrcSetter'
                }
              },
              updateComponentId: '',
              toggleVisibility: {
                show: {
                  fields: ['DIFARMA_0-IFRAME']
                }
              }
            } */
          },
          {
            name: 'IFRAME',
            value: '',
            rawValue: null,
            active: true,
            status: ['hidden'],
            errorMessage: [],
            validations: [],
            values: [],
            type: 'iframe',
            position: 4
          }
        ],
        status: [],
        errorMessage: []
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./state/static/firmeStatic.js